/* eslint-disable import/extensions */
import React from "react";
import Box from "@material-ui/core/Box";
import ExpandedBox from "./ExpandedBox";
import EventItem from "./EventItem";
import Emitter from "../../../../emitter";

const MultipleEntries = ({ classes, events, date, ...rest }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [eventsData, setEventsData] = React.useState([]);
  const [preEventsData, setPreEventsData] = React.useState([]);
  const dayContentRef = React.useRef();
  const open = Boolean(anchorEl);

  const expandItems = (e) => {
    setAnchorEl(dayContentRef.current);
    setEventsData(
      events.map((event) => {
        return { ...event, open: false };
      })
    );
  };

  const collapseItems = () => {
    setAnchorEl(null);
    setEventsData(
      events.map((event) => {
        return { ...event, open: false };
      })
    );
  };

  const handelOpened = (id) => {
    setEventsData((prevData) => {
      return prevData.map((item) => {
        if (item.id !== id) {
          return { ...item, open: false };
        } else {
          return { ...item, open: true };
        }
      });
    });
  };

  const handelOpenedPreEvents = (id) => {
    setPreEventsData((prevData) => {
      return prevData.map((item) => {
        if (item.id !== id) {
          return { ...item, open: false };
        } else {
          return { ...item, open: true };
        }
      });
    });
  };

  React.useEffect(() => {
    setEventsData(
      events.map((event) => {
        return { ...event, open: false };
      })
    );
  }, [events]);

  React.useEffect(() => {
    setPreEventsData(
      eventsData
        .filter((e, idx) => {
          return idx < 3;
        })
        .map((event) => {
          return { ...event, open: false };
        })
    );
  }, [eventsData]);

  React.useEffect(() => {
    Emitter.on("OPEN_EVENT", () => {
      setEventsData(
        events.map((event) => {
          return { ...event, open: false };
        })
      );
    });

    return () => {
      Emitter.off("OPEN_EVENT", () => {
        setEventsData(
          events.map((event) => {
            return { ...event, open: false };
          })
        );
      });
    };
  }, []);

  return (
    <Box className={classes.multipleEntriesWrapper} ref={dayContentRef}>
      {preEventsData.map((event) => (
        <EventItem
          classes={classes}
          event={event}
          itemOpened={event.open}
          handelOpened={handelOpenedPreEvents}
          {...rest}
        />
      ))}
      {eventsData.length > 3 && (
        <ExpandedBox
          classes={classes}
          events={eventsData}
          open={open}
          anchorEl={anchorEl}
          date={date}
          expandItems={expandItems}
          collapseItems={collapseItems}
          handelOpened={handelOpened}
          {...rest}
        />
      )}
    </Box>
  );
};

export default MultipleEntries;
